/**
 * 判断关系面板快照是否允许按普通几何关系删除。
 *
 * 智能尺寸派生的关系快照只用于展示，删除它必须转到尺寸领域；普通关系和历史快照保持可删。
 *
 * @param item 关系列表项。
 * @returns 非只读派生视图时返回 `true`。
 */
export function isSketchRelationSnapshotDeleteEnabled(item: unknown): boolean {
    if (!item || typeof item !== 'object') {
        return false;
    }

    return Reflect.get(item, 'isReadOnly') !== true;
}
